<template>
  <div>
    <RestoreFileAction ref="restoreAction" @reload="reloadCapture()" />    
    <v-menu v-model="menu" :close-on-content-click="false" offset-y :position-x="position.x" :position-y="position.y">
      <v-list dense>
        <!-- <v-list-tile :to="{ name: 'dataset', params: { id: file.Id }}">
          <v-list-tile-avatar>
            <v-icon>description</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>View details</v-list-tile-title>
        </v-list-tile> -->
        <v-list-tile :href="`/download/${ file.Id }`" :title="file.Name" @click.prevent="downloadFile()">
          <v-list-tile-avatar>
            <v-icon>save_alt</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Download</v-list-tile-title>
        </v-list-tile>
        <v-divider class="my-2" />
        
        <v-list-tile v-if="isTenantAdmin" @click="restore(file.Id)">
          <v-list-tile-avatar>
            <v-icon>restore</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-title>Restore file</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  import { download } from '@/helpers/download'  
  import { createNamespacedHelpers } from 'vuex'

  
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    data: () => ({
      menu: false,
      file: {},
      position: {
        x: 0,
        y: 0,
      },
      resultsTitle: '',
    }),
    computed: {
      ...authenticate.mapGetters(['isTenantAdmin']),
    },
    methods: {      
      show(file) {
        if (this.menu) return
        console.log('item', file)
        this.position = {
          x: event.clientX,
          y: event.clientY,
        }

        this.file = file
        this.menu = true
      },
      downloadFile() {
        let file = this.file
        file.loading = true

        let options = {
          successful: () => {
            file.loading = false
          },
          failedCb: (error) => {
            file.loading = false
            this.$store.dispatch('app/setSnackbar', {
              text: error,
              color: 'error',
              icon: 'error',
            })
          },
        }

        download(
          `api/RawDataRepository/file/${ file.Id }/download`,
          file.Name,
          options
        )
      },
      restore(fileId) {
        this.$refs.restoreAction.submit(fileId)
      },
      reloadCapture() {
        this.$emit('reload')
      },
    },
  }
</script>